import React, { useState } from 'react';
import { Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import API from '../../api';

function SystemNotifications({ currentSystemMessage, setCurrentSystemMessage, setMessage }) {
    const [systemMessage, setSystemMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleUpdate = () => {
        setLoading(true);
        fetch(API.SYSTEM_MESSAGE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ message: systemMessage }),
        })
        .then(response => response.json())
        .then(data => {
            setMessage(data.message);
            setLoading(false);
            if (data.status === 'success') {
                setCurrentSystemMessage(systemMessage);
                setSystemMessage('');
            }
        })
        .catch(error => { console.error('Error updating system message:', error); setLoading(false); });
    };

    return (
        <Row>
            <Col md={12}>
                <Card className="admin-panel-card">
                    <Card.Header className="admin-panel-card-header">System Notifications</Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Group controlId="formSystemMessage">
                                <Form.Label className="admin-panel-form-label">Current System Message</Form.Label>
                                <div className="admin-panel-current-message">
                                    {currentSystemMessage || 'No current system message.'}
                                </div>
                                <Form.Label className="admin-panel-form-label mt-4">New System Message</Form.Label>
                                <Form.Control type="text" value={systemMessage} onChange={(e) => setSystemMessage(e.target.value)} placeholder="Enter new system message" className="admin-panel-input" />
                            </Form.Group>
                            <Button variant="primary" onClick={handleUpdate} className="mt-3 admin-panel-button">
                                {loading ? <Spinner animation="border" size="sm" /> : 'Update System Message'}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}

export default SystemNotifications;
